<template>
    <fade-up-animation :element="() => $refs.section">
        <div class="restaurants-map-section" ref="section">
            <b-container>
                <mobile-gutter>
                    <base-map
                        :markers="restaurants"
                        :center="center"
                        hide-center-marker
                        ref="baseMap"
                    >
                        <restaurant-map-popover
                            v-for="restaurant in restaurants"
                            :key="restaurant.id"
                            :slot="`marker_info_window_${ restaurant.id }`"
                            :name="restaurant.name"
                            :address="restaurant.address"
                            :tel="restaurant.telephone_number"
                            :deliveroo-url="restaurant.deliveroo_url"
                            :uber-eats-url="restaurant.uber_eats_url"
                            :just-eat-url="restaurant.just_eat_url"
                            :to="restaurant.to"
                        />
                    </base-map>
                </mobile-gutter>
            </b-container>
        </div>
    </fade-up-animation>
</template>

<script>
    import BaseMap from '../../molecules/BaseMap/BaseMap';
    import RestaurantMapPopover from '../../molecules/RestaurantMapPopover/RestaurantMapPopover';
    import { mapState, mapActions } from 'vuex';

    export default {
        name: 'restaurants-map-section',

        components: { RestaurantMapPopover, BaseMap },

        data() {
            return {
                restaurants: [],
                center: undefined,
            };
        },

        computed: {
            ...mapState('user', [
                'lat',
                'lng',
            ]),

            /**
             * Return the current lat lng.
             *
             * @returns {undefined|{lng: number, lat: number}}
             */
            latLng() {
                if ([this.lat, this.lng].includes(null)) {
                    return undefined;
                }

                return {
                    lat: this.lat,
                    lng: this.lng,
                };
            },
        },

        watch: {
            latLng: {
                immediate: true,
                handler() {
                    if ([this.lat, this.lng].includes(null)) {
                        this.center = undefined;

                        return;
                    }

                    this.center = {
                        lat: this.lat,
                        lng: this.lng,
                    };
                },
            },
        },

        /**
         * Fetch the restaurants from the api.
         */
        async fetch() {
            const { restaurants } = await this.getRestaurants();

            this.restaurants = (restaurants || []).map((restaurant) => ({
                id: restaurant.documentId,
                name: restaurant.name,
                lat: restaurant.location_lat,
                lng: restaurant.location_lng,
                address: restaurant.address,
                telephone_number: restaurant.telephone_number,
                deliveroo_url: restaurant.deliveroo_url,
                uber_eats_url: restaurant.uber_eats_url,
                just_eat_url: restaurant.just_eat_url,
                to: restaurant.page
                    ?.uri,
            }));
        },

        mounted() {
            this.$nuxt.$on('goToRestaurant', this.goToRestaurant);
        },

        methods: {
            ...mapActions('restaurants', [
                'getRestaurants',
            ]),

            /**
             * Go to a restaurant on the map.
             *
             * @param {object} restaurant
             */
            goToRestaurant(restaurant) {
                if (!restaurant) {
                    return;
                }

                this.center = {
                    lat: restaurant.lat,
                    lng: restaurant.lng,
                };

                this.$nuxt.$emit('setMapZoom', 17);
                this.$nuxt.$emit('openMarker', restaurant.id);
            },
        },
    };
</script>
